import type { PaymentMethod } from "@mallardbay/lib-react-components"
import type { PaymentMethod as StripePaymentMethod } from "@stripe/stripe-js"

import { PaymentBlockType } from "~graphql/generated/graphql"
import COPY from "~config/copy-constants"

// TODO: A lot of this is in server. Move to shared JS lib.

export function mapStripePaymentMethodToPaymentMethod(
    paymentMethod: StripePaymentMethod
) {
    if (isCardPaymentMethod(paymentMethod)) {
        return mapCardToPaymentBlock(paymentMethod)
    }

    if (isBankPaymentMethod(paymentMethod)) {
        return mapBankToPaymentBlock(paymentMethod)
    }

    return null
}

function mapCardToPaymentBlock(
    paymentMethod: StripeCardPaymentMethod
): PaymentMethod {
    return {
        id: paymentMethod.id,
        title: getPaymentBlockTitleForCard(paymentMethod.card),
        subtitle: getPaymentBlockSubtitleForCard(paymentMethod.card),
        type: PaymentBlockType.Card,
        brand: paymentMethod.card.brand,
        is_default: false,
    }
}

function getPaymentBlockTitleForCard(card: StripePaymentMethod.Card): string {
    return `${card.brand}  • • • •  ${card.last4}`
}

function getPaymentBlockSubtitleForCard(
    card: StripePaymentMethod.Card
): string {
    const expMonth = card.exp_month
    const formattedMonth = expMonth >= 10 ? expMonth : `0${expMonth}`

    return `${COPY.EXPIRATION}: ${formattedMonth}/${card.exp_year}`
}

function mapBankToPaymentBlock(
    paymentMethod: StripeBankPaymentMethod
): PaymentMethod {
    return {
        id: paymentMethod.id,
        title: paymentMethod.us_bank_account.bank_name,
        subtitle: getPaymentBlockSubtitleForBank(paymentMethod.us_bank_account),
        type: PaymentBlockType.BankAccount,
        brand: null,
        is_default: false,
    }
}

function getPaymentBlockSubtitleForBank(
    bank: StripePaymentMethod.UsBankAccount
): string {
    return `${bank.account_type}  • • • •  ${bank.last4}`
}

function isCardPaymentMethod(
    paymentMethod: StripePaymentMethod
): paymentMethod is StripeCardPaymentMethod {
    return Boolean(paymentMethod.card)
}

function isBankPaymentMethod(
    paymentMethod: StripePaymentMethod
): paymentMethod is StripeBankPaymentMethod {
    return Boolean(paymentMethod.us_bank_account)
}

interface StripeCardPaymentMethod extends StripePaymentMethod {
    card: StripePaymentMethod.Card
}

interface StripeBankPaymentMethod extends StripePaymentMethod {
    us_bank_account: StripePaymentMethod.UsBankAccount
}
